import NextImage from 'next/image'

import { Media } from '@/templates/Media/Media'

function Desktop({ src }: { src: string }) {
  return (
    <Media
      className="max-w-4xl overflow-hidden rounded-md lg:w-2/3 xl:max-w-5xl"
      greaterThanOrEqual="lg"
    >
      <figure>
        <NextImage
          alt={src}
          src={src}
          height="40px"
          width="100%"
          layout="responsive"
          priority
          quality={75}
        />
      </figure>
    </Media>
  )
}

export default Desktop
